import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link } from 'react-router-dom';


const useStyles = makeStyles((theme) => ({
    root: {
        paddingBottom: 20,
    },
    container: {
        display: 'flex',
        overflowY: 'hidden',
        overflowX: 'auto',
        gap: 20,
        padding: '0 20px',
        margin: '0 auto',
        maxWidth: 1500,
        height: 220,
        '& .MuiPaper-root': {
            display: 'flex',
            flexDirection: 'column',
            placeItems: 'center',
            maxHeight: 200,
            minWidth: 150,
            width: 150,
        },
        '& > *': {
            padding: 10,
        },
        '& *': {
            margin: 0,
        }
    },
}));


export default function RecentViewedBar(props) {
    const classes = useStyles();

    const viewedProduct = props.viewedProduct;
    const counter = props.counter;

    const [checked, setChecked] = React.useState(false);

    useEffect(() => {
        sessionStorage.setItem('recentViewed', JSON.stringify(viewedProduct));
    }, [counter])

    const handleChange = () => {
        setChecked((prev) => !prev);
    };

    return (
        <section className="recent-viewed-bar">
            <div className={classes.root}>
                <FormControlLabel
                    control={<Switch checked={checked} onChange={handleChange} />}
                    label="Recent viewed products."
                    style={{ marginLeft: 20 }}
                />
                <div className={classes.container}>
                    {viewedProduct && viewedProduct.map((item, index) => (
                        <Grow in={checked} key={index} {...(checked ? { timeout: 500 * index + 500 } : {})}>
                            <Paper elevation={1} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <h5>{item.item.name}</h5>
                                <Link to={`/details/${item.item.name}`}>
                                    {item.item.image[0] === ''
                                        ? <img src='no-image.png' alt="" style={{ maxWidth: '100%' }} />
                                        : <img alt="" src={item.item.image[0].replace('..', '/react-web-shop')} style={{ width: '100%' }} />
                                    }
                                </Link>
                            </Paper>
                        </Grow>
                    ))}
                </div>
            </div>
        </section>
    )
}
